import React from 'react';
import './ServiceCards.css';

const steps = [
  {
    title: 'Разбираемся в задаче',
    text: 'Изучаем, как устроена работа сейчас: кто участвует, где теряется время и какие есть ограничения.',
    label: 'ПРОЦЕССЫ И ОГРАНИЧЕНИЯ',
  },
  {
    title: 'Проектируем',
    text: 'Определяем состав решения, связи между системами и этапы разработки. Фиксируем, что должно получиться.',
    label: 'АРХИТЕКТУРА И ПЛАН',
  },
  {
    title: 'Разрабатываем',
    text: 'Пишем код, подключаем данные и собираем решение по согласованному плану.',
    label: 'КОД И ИНТЕГРАЦИИ',
  },
  {
    title: 'Запускаем',
    text: 'Проверяем всё на рабочих сценариях вместе с вашей командой. Вносим правки и передаём решение в эксплуатацию.',
    label: 'ПРОВЕРКА И ПЕРЕДАЧА',
  },
];

const ProcessSection: React.FC = () => (
  <section
    aria-labelledby="process-title"
    className="process-section section-space"
    id="Process"
  >
    <div className="landing-container">
      <div
        className="section-heading"
        data-flow-reveal
      >
        <p className="eyebrow">
          <span className="section-index">03 /</span>
          {' '}
          КАК РАБОТАЕМ
        </p>
        <div className="heading-columns">
          <h2 id="process-title">
            От задачи
            <br />
            <span className="muted-title">до рабочего решения.</span>
          </h2>
          <p>
            До начала разработки согласуем задачу, границы проекта и критерии готовности.
            {' '}
            По ходу работы показываем результат и уточняем следующий шаг.
          </p>
        </div>
      </div>
      <ol
        className="process-grid"
        data-flow-reveal
      >
        {steps.map((step) => (
          <li
            key={step.title}
            className="process-card"
          >
            <div className="process-card-heading">
              <span className="process-label">{step.label}</span>
              <h3>{step.title}</h3>
            </div>
            <p className="process-card-description">{step.text}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default ProcessSection;
